import React, { useState, useRef } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import "../../../src/main.css";
import Cross from "assets/svgs/cross";

function AllInputSearch(props) {
  const [inputChange, setInputChange] = useState("");

  const handleClick = () => {
    props.handleSearch(inputChange);
  };
  
  const handleChange = (value) => {
    props.handleChange(value)
    setInputChange(value);
  };

  const handleClear = () => {
    props.handleChange("")
    setInputChange("");
  };

  return (
    <div className="mt-n5">
      <InputGroup className="input-search rounded-left">
        <div className="d-flex flex-fill border border-end-0 bg-white align-items-center pe-1 ps-2 rounded-left">
          <input
          style={{outline:0}}
            onChange={(event) => {
              handleChange(event.target.value);
            }}
            value={inputChange}
            placeholder="Ticket Number / Name / Email Id / Case Id / Order Id"
            className="border-0 w-100 "
          />
          {inputChange && (
            <span onClick={handleClear} className="ms-n4">
              <Cross />
            </span>
          )}
        </div>
        <InputGroup.Text
          id="basic-addon2"
          className="bg-primary text-white fs-1 border-0"
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          Search
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
}

export default AllInputSearch;
